import React from 'react';
import classes from './Europe.module.scss';

const Europe = () => {

    const withNoise = true;

    function Noise(props: any) {
        const noise = props.noise;
        if (noise) {
            return <div className={classes.noise}/>;
        }
        return <div/>;
    }

    return (
        <div id="home" className={classes.headerContainer}>
            <div className={classes.header}>
                <Noise noise={withNoise}/>
            </div>
        </div>
    );
};

export default Europe;
